import * as Sentry from '@sentry/react'
import React from 'react'
import { createRoot } from 'react-dom/client'

import Bootstrap from './App/Bootstrap'
import { MenuBootstrap } from './Menu/Bootstrap'

import './App/i18n'

Sentry.init({
  dsn: '',
  tracesSampleRate: 0.3,
  debug: false,
  integrations: [new Sentry.BrowserTracing()],
})

const reactContainer = document.getElementById('reactRoot')
if (null !== reactContainer) {
  const reactRoot = createRoot(reactContainer) // createRoot(container!) if you use TypeScript
  reactRoot.render(<Bootstrap />)
}

const menuReactContainer = document.getElementById('menuReactRoot')
if (null !== menuReactContainer) {
  const menuReactRoot = createRoot(menuReactContainer) // createRoot(container!) if you use TypeScript
  menuReactRoot.render(<MenuBootstrap />)
}
